class OlsunFooter extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.mobile = matchMedia('(max-width: 749px)');
    const update = () => {
      this.querySelectorAll('.oft__group').forEach(group => {
        group.open = !this.mobile.matches;
        const summary = group.querySelector('summary');
        if (this.mobile.matches) summary.removeAttribute('tabindex');
        else summary.tabIndex = -1;
      });
    };
    this.mobile.addEventListener('change', update, { signal: this.controller.signal });
    this.addEventListener('toggle', event => {
      if (!this.mobile.matches && event.target.matches('.oft__group') && !event.target.open) event.target.open = true;
    }, { capture: true, signal: this.controller.signal });
    document.addEventListener('shopify:block:select', event => {
      if (this.contains(event.target)) event.target.closest('.oft__group')?.setAttribute('open', '');
    }, { signal: this.controller.signal });
    update();
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('olsun-footer')) customElements.define('olsun-footer', OlsunFooter);
